import { array, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';

interface Params {
    timeIntervals: { firstTimeUnitStartUtc: string; lastTimeUnitStartUtc: string }[];
}

/*
    Finds indices of overlapping time intervals in an array.
    This algorithm is a modified version of the one here: https://www.geeksforgeeks.org/check-if-any-two-intervals-overlap-among-a-given-set-of-intervals/
 */
export const findOverlappingIntervalIndices = ({ timeIntervals }: Params) => {
    const startTimeOrd = pipe(
        string.Ord,
        ord.contramap(
            (interval: { firstTimeUnitStartUtc: string; lastTimeUnitStartUtc: string }) =>
                interval.firstTimeUnitStartUtc
        )
    );

    const sortedIntervals = pipe(timeIntervals, array.sort(startTimeOrd));
    return pipe(
        sortedIntervals,
        array.reduceWithIndex([] as number[], (i, acc, curr) => {
            const overlap = sortedIntervals
                .slice(0, i)
                .some((prev) => prev.lastTimeUnitStartUtc >= curr.firstTimeUnitStartUtc);

            return overlap ? [...acc, i] : acc;
        })
    );
};
